import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthBypassBanner from './AuthBypassBanner';
import InstallPrompt from './InstallPrompt';

const Layout = () => {
  const { user, loading, logout, authBypassActive } = useAuth();
  return (
    <div>
      <InstallPrompt />
      <nav className="app-nav">
        <div className="app-nav__links">
          <NavLink to="/teacher" end className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
            Home
          </NavLink>
          <NavLink to="/library" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
            Library
          </NavLink>
          <NavLink to="/sca" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
            SCA Practice
          </NavLink>
          {user?.is_admin && (
            <NavLink to="/admin/tts" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
              TTS Settings
            </NavLink>
          )}
        </div>
        <div className="app-nav__user">
          {loading ? (
            <div className="skeleton-row">
              <span className="skeleton skeleton-avatar" />
              <span className="skeleton skeleton-line skeleton-line--wide" />
            </div>
          ) : user ? (
            <>
              <span className="app-nav__name">
                {user.name} ({user.email})
              </span>
              <button onClick={logout}>Logout</button>
            </>
          ) : (
            <NavLink to="/login" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
              Login
            </NavLink>
          )}
        </div>
      </nav>
      {authBypassActive && <AuthBypassBanner />}
      <main style={{ padding: 24 }}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
